import Vue from 'vue';

const getPayloadToken = token => Vue.axios.get(`/payload-tokens/${token}`);
const getQuote = (token, body) => Vue.axios.post(`/payload-tokens/${token}/quote-order/`, body);
const createOrder = (token, body) => Vue.axios.post(`/payload-tokens/${token}/create-order/`, body);
const getOpenEndedToken = token => Vue.axios.get(`/pcw-tokens/${token}/`);
const getInternalQuote = body => Vue.axios.post('/pricing/quote', body);
const validatePCWToken = ({ token, client }) => Vue.axios.get(`/clients/${client}/pcw-token?token=${token}`);

export default {
  getPayloadToken,
  getQuote,
  createOrder,
  getOpenEndedToken,
  getInternalQuote,
  validatePCWToken,
};
